import { FC, PropsWithChildren } from 'react';

import styles from './PlayerResult.module.scss';

const PlayerResult: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.result}>{children}</div>;
};

export default PlayerResult;
